const NAMESPACE = 'dataLayer'

const gtmPush = obj => {
  if (!window) return false

  if (window[NAMESPACE] === undefined) {
    window[NAMESPACE] = []
  }

  window[NAMESPACE].push(obj)

  return window[NAMESPACE]
}

const postSend = (event, formType, inputs, scroll = false) => {
  const gtmData = { event: 'enquirySent', enquiryType: formType }

  for (var name in inputs) {
    if (inputs.hasOwnProperty(name)) {
      const input = inputs[name]
      const isCheckbox =
        input.current && input.current.getAttribute('type') === 'checkbox'

      if (isCheckbox) {
        gtmData[name] = input?.current.checked
      } else {
        gtmData[name] = input?.current?.value || ''
      }
    }
  }

  gtmPush(gtmData)

  scroll &&
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
}

export { gtmPush, postSend }
